import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { Endpoint } from '../../constants/endpoints';

@Controller({ fragment: 'dashboard', component: 'main-layout' })

export default class DashboardControler {

  @OnMount('main-layout')
  onMount(): void {
    const duplicateFileProtocol = false;

    HttpService.get(Endpoint.GET_FILE_PROTOCOL, { id: 251451 }).then((response) => {
      console.log(response);
    }).finally(() => {
      console.log('');
    });

    if(duplicateFileProtocol) {
      HttpService.post(Endpoint.DUPLICATE_FILE_PROTOCOL,
        {},
        { body: { code: 251475, username: 'ejsilva' }  }).then((response) => {
        console.log(response);
      }).finally(() => {
        console.log('');
      });
    }
  }
}
